<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-text>
                        <v-row>
                            <s-select-definition
                                :def="1423"
                                @getDataInitial="GetColumns($event)"
                                hidden
                            ></s-select-definition>
                            <s-select-definition
                                :def="1424"
                                @getDataInitial="GetRows($event)"
                                hidden
                            ></s-select-definition>
                        </v-row>
                        <v-row justify="center">
                            <v-col cols="auto" align="center" v-for="item in columns" :key="item.DedAbbreviation">
                                <b>{{ item.DedDescription }}</b>
                                <v-card style="box-shadow: none;">
                                <v-container style="padding: 1.5rem; box-sizing: border-box; display: flex; flex-direction: column; gap: 7px">
                                    <v-row v-for="item2 in rows" :key="item2.DedAbbreviation">
                                    <v-row dense>
                                        <v-col>
                                        <!-- Obtener el doll de la posición actual -->
                                        <template v-if="getDollByPosition(item, item2)">
                                            <v-card
                                                :disabled="isDisabledCard(item, item2)"
                                                hover
                                                :class="[
                                                    getDollByPosition(item, item2)?.DlpTypeDiscard === 1 ? 'bg-green' :
                                                    getDollByPosition(item, item2)?.DlpTypeDiscard === 2 ? 'bg-orange' : 'bg-white',
                                                    {
                                                        selectedDoll: tableClickSelectedID == item.DedAbbreviation + item2.DedAbbreviation,
                                                        Doll: tableClickSelectedID != item.DedAbbreviation + item2.DedAbbreviation,
                                                        'disabled-card': isDisabledCard(item, item2)
                                                    }
                                                ]"
                                                @click="emitLocation({ item, item2 })"
                                            >
                                            <v-card-text>
                                                <h4>{{ item.DedDescription + item2.DedDescription }}</h4>
                                            </v-card-text>
                                            </v-card>
                                        </template>

                                        <template v-else>
                                            <v-card
                                            hover
                                            :class="{
                                                selectedDoll: tableClickSelectedID == item.DedAbbreviation + item2.DedAbbreviation,
                                                Doll: tableClickSelectedID != item.DedAbbreviation + item2.DedAbbreviation
                                            }"
                                            @click="emitLocation({ item, item2 })"
                                            >
                                            <v-card-text>
                                                <h4 :style="{ color: tableClickSelectedID == item.DedAbbreviation + item2.DedAbbreviation ? 'white' : 'black' }">{{ item.DedDescription + item2.DedDescription }}</h4>
                                            </v-card-text>
                                            </v-card>
                                        </template>
                                        </v-col>
                                    </v-row>
                                    </v-row>
                                </v-container>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
 import _armedDoolService from '@/services/FrozenProduction/ArmedDollService'

export default {
    props: {
        DlpTypeDiscard : {
            type: Number,
            default: 0
        }
    },
    data(){
        return{
            dollStore: [],
            columns: [],
			rows: [],
            tableClickSelectedID: 0
        }
    },
    methods:
    {
        isDisabledCard(item, item2) {
            if (this.DlpTypeDiscard === 1) {
                const doll = this.getDollByPosition(item, item2);
                return !(doll && doll.DlpTypeDiscard === 1);
            }

            if (this.DlpTypeDiscard === 2) {
                const doll = this.getDollByPosition(item, item2);
                return !(doll && doll.DlpTypeDiscard === 2);
            }

            if (this.DlpTypeDiscard === 3) {
                const doll = this.getDollByPosition(item, item2);
                return !(doll && doll.DlpTypeDiscard === 3);
            }

            return false;
        },
        getDollByPosition(item, item2) {
            const pos = item.DedDescription + item2.DedDescription;
            return this.dollStore.find(d => d.DlpPosition === pos) || null;
        },
        emitLocation({ item, item2 }) {
            console.log('emitLocation', { item, item2 });
            this.$emit("emitLocation", { item, item2 });
            this.tableClickSelectedID = item.DedAbbreviation + item2.DedAbbreviation;
        },
        toggleSelection(item2) {
      // Toggle the selected state of the card
            item2.selected = !item2.selected;
        },
        listStore()
        {				
            let processInitialData = localStorage.getItem('processInitialData');
			processInitialData = JSON.parse(processInitialData);
            console.log('this.processInitialData', processInitialData);
            _armedDoolService.listStore({TypeCultive: processInitialData?.TypeCultive}, this.$fun.getUserID())
            .then((r) => {
                if (r.status == 200) {
                    console.log('this.listStoreED', r.data);
                    this.dollStore = r.data;
                }
            })
        },
        clickFilterDoll(){
            let processInitialData = localStorage.getItem('processInitialData');
			processInitialData = JSON.parse(processInitialData);

            _armedDoolService.listDollFilter({TypeCultive: processInitialData?.TypeCultive}, this.$fun.getUserID()).then(r => {
                if(r.status == 200){
                    // this.itemsDollFilter= r.data
                    console.log('this.listDollFilter', r.data);
                    this.dollStore = r.data;                    
                }
            })
        },
        GetColumns(items) {
				this.columns = items;				
			},

			GetRows(items)
			{
				this.rows = items;				
			},
    },
    watch: {
        DlpTypeDiscard(newVal) {
            const selected = this.columns.flatMap(col =>
            this.rows.map(row => ({
                item: col,
                item2: row,
                key: col.DedAbbreviation + row.DedAbbreviation
            }))
            ).find(x => x.key === this.tableClickSelectedID);

            if (!selected) return;

            const doll = this.getDollByPosition(selected.item, selected.item2);

            if (!doll) return;

            let isInvalid = false;

            if (newVal === 1) isInvalid = doll.DlpTypeDiscard !== 1;
            else if (newVal === 2) isInvalid = doll.DlpTypeDiscard !== 2;
            else if (newVal === 3) isInvalid = true;

            if (isInvalid) {
                this.tableClickSelectedID = 0;
                console.log('this.tableClickSelectedID', this.tableClickSelectedID);
                this.$emit('emitInvalidSelection');
            }
        }
    },
    created(){
        this.clickFilterDoll();
        this.listStore();

        console.log('this.DlpTypeDiscard', this.DlpTypeDiscard);
    }
}
</script>

<style scoped>
.selected {
    border: 2px solid #42a5f5; /* Color del borde del card seleccionado */
}
/* .Doll{
    background-color: #5edf87
} */

.bg-green {
  background: linear-gradient(135deg, #28e32e 0%, #12a119 100%);
  color: white;
  border: 3px solid green;
}

.bg-orange {
  background: linear-gradient(135deg, #eea647 0%, #ff9100 100%);
  color: white;
  border: 3px solid orange;
}

.bg-white{
  background: linear-gradient(135deg, #b2b2b4 0%, #757577 100%);
  color: white;
  border: 3px solid #6d6d6d;
}

.disabled-card {
  pointer-events: none;
  opacity: 0.7;
  cursor: not-allowed;
}

.selectedDoll{
    background: #0800ff !important;
}
</style>